import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { galleryCategories } from '../data/gallery';
export function Projects() {
  return <section className="w-full overflow-hidden bg-shell py-16 lg:py-24" data-id="element-174" data-mp="fxlwvx7q36cu">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-175" data-mp="ulgsbld47otm">
        <SectionHeading overline="Real creations" size="lg" title={<>
              Everything you can make with{' '}
              <span className="italic text-terracotta-500" data-id="element-177" data-mp="13jipfptq9xbm">this guide</span>
            </>} data-id="element-176" data-mp="ptyngm7z143d" />

        <div className="mt-14 grid grid-cols-2 gap-3 sm:gap-5" data-id="element-178" data-mp="yod2qosi4emh">
          {galleryCategories.map(category => <figure key={category.name} className="group flex h-full flex-col overflow-hidden rounded-3xl border border-gold-200/60 bg-cream" data-id="element-179" data-mp="18kgemmd5nrmm">
              <div className="overflow-hidden" data-id="element-180" data-mp="3fcr05jkhili2">
                <img src={category.image} alt={category.name} className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-soft group-hover:scale-[1.04]" data-id="element-181" data-mp="3acuvdi3yqq1g" />
              </div>
              <figcaption className="px-3 py-4 text-center sm:px-6 sm:py-6" data-id="element-182" data-mp="26cpc8fum5sh2">
                <p className="font-serif text-[1.1rem] leading-tight text-sage-800 sm:text-[1.5rem]" data-id="element-183" data-mp="26amgdf6s554f">
                  {category.name}
                </p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}